export default "__VITE_ASSET__CD80nJ5h__"